import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=517e2da5"
import script from "./CarouselCard.vue?vue&type=script&lang=js"
export * from "./CarouselCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductTaxonLink: require('/opt/build/repo/components/product/TaxonLink.vue').default,ProductPrice: require('/opt/build/repo/components/product/Price.vue').default})
